module.exports = __webpack_public_path__ + "static/media/9.360b45bb.JPG";